'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Empty = require('./Empty');

var _Empty2 = _interopRequireDefault(_Empty);

var _Full = require('./Full');

var _Full2 = _interopRequireDefault(_Full);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = { Empty: _Empty2.default, Full: _Full2.default };


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Dots/index.js
// module id = 1172
// module chunks = 1